import * as React from 'react';

import { Table } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { DataTableEndlessPaginated } from '@/components/data-table/data-table-endless-paginated';
import { StickyTableStateContent } from '@/components/data-table/data-table-states';

import { MemberAccessRow } from '../../types/member-access';

interface MemberAccessTableProps {
  table: Table<MemberAccessRow>;
  isLoading: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
  error?: string | null;
  stickyHeader?: boolean;
  fixedHeight?: boolean;
  tableId?: string;
  onResizeEnd?: () => void;
}

export const MemberAccessTable: React.FC<MemberAccessTableProps> = ({
  table,
  isLoading,
  hasMore,
  onLoadMore,
  error,
  stickyHeader = false,
  fixedHeight = false,
  tableId,
  onResizeEnd,
}) => {
  const { t } = useTranslation('common');

  const colSpan = table.getAllColumns().length;

  const renderEmptyState = (): React.ReactNode => (
    <tr>
      <td colSpan={colSpan} className="h-16 w-full px-0">
        <StickyTableStateContent className="px-12 py-4">
          <div className="text-sm">{t('noResultsFound')}</div>
        </StickyTableStateContent>
      </td>
    </tr>
  );

  return (
    <DataTableEndlessPaginated
      table={table}
      isLoading={isLoading}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      error={error ?? undefined}
      renderEmptyState={renderEmptyState}
      stickyHeader={stickyHeader}
      fixedHeight={fixedHeight}
      tableId={tableId}
      onResizeEnd={onResizeEnd}
    />
  );
};
